/*
 * RUNIC CUSTOMIZED
 */

/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {useAuth} from '../../../../app/modules/auth'
import {getUser} from '../../../../app/modules/auth/core/_requests'

const HeaderUserMenu: FC = () => {
  const {currentUser, stopImpersonation, logout, saveAuth, auth, setCurrentUser, userVerifyRoles} = useAuth()

  const navigate = useNavigate()

  const onEndImpersonation = async () => {
    await stopImpersonation();

    navigate(`/`)
  }

  const isImpersonation = currentUser?.isImpersonating
  const isCompanyModerator = userVerifyRoles(['Company Moderator'])


  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      {/*{isCompanyModerator && (*/}
      {/*    <div className='menu-item px-5'>*/}
      {/*      <a href='#' className='menu-link px-5'>*/}
      {/*        Company Profile*/}
      {/*      </a>*/}
      {/*    </div>*/}
      {/*)}*/}


      {/*<div className='separator my-2'></div>*/}

      <div className='menu-item px-5 my-1'>
        <Link to={'/user/account/settings/' + currentUser?.id} className='menu-link px-5'>
          Account Settings
        </Link>
      </div>

      {isImpersonation && (
        <div className='menu-item px-5 my-1'>
          <span
            className='menu-link px-5 my-1'
            role='button'
            tabIndex={0}
            onClick={onEndImpersonation}
            aria-label='End Impersonation'
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                onEndImpersonation()
              }
            }}
          >
            End Impersonation
          </span>
        </div>
      )}

      <div className='menu-item px-5'>
        <a onClick={logout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
